import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';
import { MyspaceLayoutComponent } from './features-modules/my-space/myspace-layout/myspace-layout.component';
import { AuthLayoutComponent } from './features-modules/auth/auth-layout/auth-layout.component';
import { OttLayoutComponent } from './features-modules/ott/ott-layout/ott-layout.component';
import { EventsLayoutComponent } from './features-modules/events/events-layout/events-layout.component';
import { AllVideosComponent } from './features-modules/videos/all-videos/all-videos.component';
import { LoginComponent } from './features-modules/auth/login/login.component';
import { PointLeaderboardComponent } from './features-modules/ranking/point-leaderboard.component';
import { RatingLeaderboardComponent } from './features-modules/rating-leaderboard/rating-leaderboard.component';
import { MembershipLayoutComponent } from './features-modules/membership/membership-layout/membership-layout.component';
import { SubLicensesComponent } from './features-modules/sub-licenses/sub-licenses.component';
import { SubLicenseManagementComponent } from './features-modules/sub-licenses/sub-license-management/sub-license-management.component';
export const routes: Routes = [
  // Keep all ranking URL variants on a single route config so Angular reuses
  // the same component instance instead of destroying/recreating it.
  {
    matcher: (segments: UrlSegment[]): UrlMatchResult | null => {
      if (segments.length === 0 || segments[0].path !== 'ranking' || segments.length > 3) {
        return null;
      }

      const posParams: { [key: string]: UrlSegment } = {};
      if (segments[1]) posParams['levelId'] = segments[1];
      if (segments[2]) posParams['categoryId'] = segments[2];

      return {
        consumed: segments,
        posParams,
      };
    },
    component: PointLeaderboardComponent,
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  {
    path: '',
    component: MyspaceLayoutComponent,
    children: [
      {
        path: 'my-space',
        loadChildren: () =>
          import('./features-modules/my-space/my-space.module').then(
            (m) => m.MySpaceModule
          ),
      },
      {
        path: 'order-history',
        loadChildren: () =>
          import('./features-modules/order-history/order-history.module').then(
            (m) => m.orderHistoryModule
          ),
      },
      {
        path: 'home/orders/payment',
        loadComponent: () =>
          import(
            './features-modules/orders/order-payment-redirect/order-payment-redirect.component'
          ).then((m) => m.OrderPaymentRedirectComponent),
      },
      {
        path: 'registration',
        loadChildren: () =>
          import('./features-modules/registration/registration.module').then(
            (m) => m.RegistrationModule
          ),
      },
      {
        path: 'rating',
        component: RatingLeaderboardComponent,
      },
      {
        path: 'events',
        loadChildren: () =>
          import('./features-modules/events/events.module').then(
            (m) => m.EventsModule
          ),
      },
      {
        path: 'broadcasts',
        loadChildren: () =>
          import('./features-modules/events/events.module').then(
            (m) => m.EventsModule
          ),
      },
      {
        path: 'videos',
        loadChildren: () =>
          import('./features-modules/videos/videos.module').then(
            (m) => m.VideosModule
          ),
      },
      {
        path: 'live',
        loadChildren: () =>
          import('./features-modules/videos/videos.module').then(
            (m) => m.VideosModule
          ),
      },
      {
        path: 'scorecard',
        loadChildren: () =>
          import('./features-modules/scorecards/scorecards.module').then(
            (m) => m.ScorecardModule
          ),
      },
      {
        path: 'home',
        loadChildren: () =>
          import('./features-modules/home/home.module').then(
            (m) => m.HomeModule
          ),
      },
      {
        path: 'license',
        loadComponent: () =>
          import('./features-modules/licenses/licenses.component').then(
            (m) => m.LicensesComponent
          ),
      },
    ],
  },
  // {
  //   path: '',
  //   component: AuthLayoutComponent,
  //   children: [
  //     {
  //       path: 'account',
  //       loadChildren: () =>
  //         import('./features-modules/auth/auth.module').then(
  //           (m) => m.AuthModule
  //         ),
  //     },
  //   ],
  // },
  {
    path: 'ott',
    component: OttLayoutComponent,
    loadChildren: () =>
      import('./features-modules/ott/ott.module').then((m) => m.OttModule),
  },
  {
    path: 'membership',
    component: MyspaceLayoutComponent,
    loadChildren: () =>
      import('./features-modules/membership/membership.module').then(
        (m) => m.MembershipModule
      ),
  },
  {
    path: 'my-profile-dashboard',
    loadChildren: () =>
      import('./features-modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
  },
  {
    path: 'sub-licenses', component: SubLicensesComponent, children: [
      { path: 'sub-license-management/:id/:tab_index/:event_tab_index', component: SubLicenseManagementComponent },
    ]
  },
  { path: '**', redirectTo: '/home', pathMatch: 'full' },
];